import { Component } from '@angular/core';

@Component({
  selector: 'app-lock',
  imports: [],
  templateUrl: './lock.component.html',
  styleUrl: './lock.component.scss'
})
export class LockComponent {

}
